import { Chart } from "@appretio/ui-kit";
import { RrpMetricsGroup } from "../../../pages/inSeasonReviewPage/hooks/useFetchRrpKPIs";
import { chartWrapper } from "../Chart.css";
import { useRrpKPIsChartOptions } from "./hooks/useRrpKPIsChartOptions";

interface RrpMetricsChartProps {
  /**
   * Full dataset
   */
  rrpKPIsData: RrpMetricsGroup[];

  /**
   * Loading state
   */
  isLoading: boolean;
}

export function RrpKPIsChart({ rrpKPIsData, isLoading }: RrpMetricsChartProps) {
  const TITLE = "Sales, Purchase & Sellthrough per RRP";

  const { series, axes } = useRrpKPIsChartOptions({
    rrpKPIsData
  });

  return (
    <div className={chartWrapper}>
      <Chart
        isLoading={isLoading}
        options={{
          animation: { enabled: false },
          title: { text: TITLE },
          series,
          axes,
          legend: { position: "right-top" },
          tooltip: { mode: "single", range: "exact" },
          zoom: {
            axes: "xy",
            enabled: rrpKPIsData.length > 0,
            enableSelecting: true,
            enableAxisDragging: false,
            anchorPointX: "pointer",
            anchorPointY: "pointer",
            panKey: "shift",
            autoScaling: {
              enabled: true
            }
          }
        }}
      />
    </div>
  );
}
